import { Component } from '@angular/core';

import { environment } from '@env/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  disclaimer: string;
  version: string;

  constructor() {
    this.version = environment.version;
    this.disclaimer = `<p>The job information and data provided here are for informational purposes only, are based
    in whole or in part on estimates, and do not represent any type of promise or prediction
    of future performance or employment. PAST PERFORMANCE AND THE INFORMATION CONTAINED HERE
    ARE NO GUARANTEE OF FUTURE PAY RESULTS, REVENUE, MILES, OR HOME TIME. NO RIGHT TO
    EMPLOYMENT, CONTINUED EMPLOYMENT, SPECIFIC EMPLOYMENT, OR A MINIMUM AMOUNT OF MILES OR
    HOME TIME, OR SPECIFIC PAY AMOUNT IS GUARANTEED OR CREATED BY THIS DATA OR THE USE OF THIS
    SITE. ANY AMOUNTS IN ANY CATEGORIES ON THIS SITE WILL NOT REFLECT ACTUAL FUTURE RESULTS.
    Your actual pay, mileage, and home time will vary from these numbers depending on many
    factors, which may include tenure-based pay rates, your fleet, how hard you work, company
    performance, and how much you drive, among other factors. Because precise rate of pay can
    be difficult to guarantee in various pay structures common in the transportation industry,
    you are only guaranteed applicable minimum wage for hours worked in a given pay period.
    Please Click or Tap <a href="https://www.crengland.com/driver-jobs/disclaimer/">HERE</a> for additional disclaimer information and additional detail about
    how this data is generated.</p>`;
  }
}
